import React, { useState, useEffect } from 'react';
import { Container, Box, MenuItem, Typography, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { Brightness4 as DarkModeIcon, Brightness7 as LightModeIcon } from '@mui/icons-material';

import Header from './components/Header';
import Footer from './components/Footer';
import QueryForm from './components/QueryForm';
import ResultDisplay from './components/ResultDisplay';
import NFTService from './services/NFTService';
import ipfsService from './services/IPFSService';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import './App.css';

function AppContent() {
  const { themeMode, toggleTheme, theme } = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [nftData, setNftData] = useState(null);
  const [nftService] = useState(new NFTService());

  const handleFetchDetails = async (tokenId) => {
    setIsLoading(true);
    setError('');
    
    try {
      const data = await nftService.getCompleteNFTDetails(tokenId);
      setNftData(data);
    } catch (error) {
      console.error('Error fetching NFT details:', error);
      setError(
        error.message.includes('nonexistent token') 
          ? `Record #${tokenId} does not exist or is not a valid Evidencer record.`
          : `Failed to fetch record details: ${error.message}`
      );
      setNftData(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div className={`app-container ${themeMode}-mode`}>
        <Header />
        
        <main className="main-content">
          <Container maxWidth="lg" className="content-container">
            <Box className="banner-container">
              <img
                src={ipfsService.getPrimaryGatewayUrl('QmcDB9X3GzkyX1uBvtp7Rp2bBisvtmnT25rYr1mhmQgG5f')}
                alt="FreeWeb3"
                className="banner-image"
              />
            </Box>

            <section id="query" className="query-section">
              <Typography variant="h4" component="h2" className="section-title">
                Evidencer Record Query
              </Typography>
              
              <div className="theme-toggle">
                <MenuItem onClick={toggleTheme}>
                  {themeMode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
                </MenuItem>
              </div>
              
              <QueryForm 
                onFetchDetails={handleFetchDetails} 
                isLoading={isLoading} 
              />
              
              <ResultDisplay 
                isLoading={isLoading}
                error={error}
                nftData={nftData}
              />
            </section>
          </Container>
        </main>
        
        <Footer />
      </div>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;